export default "__VITE_ASSET__de747565__"